import type { ReactElement } from 'react';
import { PageHeader } from '@/shared/ui';
import { ExhibitionManager } from '@/widgets/exhibition-manager';

/** 기획전 관리 — 고객 기획전 페이지의 목적 탭과 기획전 카드를 만든다. */
export const ExhibitionsPage = (): ReactElement => (
  <>
    <PageHeader
      title="기획전 관리"
      description="목적 탭과 기획전 카드(대표 이미지·납기·묶인 상품) 관리"
    />

    <ExhibitionManager />
  </>
);
